import { useState } from 'react';
import { Info, X } from 'lucide-react';
import { Card, IconButton, buttonVariants, cn } from '@wundo/ui';
import { helpUrl } from '@wundo/shared/helpUrl.ts';
import { dismissTeamIntro, teamIntroDismissed } from '@/lib/teamIntroDismissed.ts';
import { m } from '@/paraglide/messages.js';
import { getLocale } from '@/paraglide/runtime.js';

/**
 * What the Team page is built from and how a colleague's info fills up. Once
 * closed, it stays away in this browser.
 */
export function TeamIntroBanner() {
  const [dismissed, setDismissed] = useState(teamIntroDismissed);
  if (dismissed) return null;

  return (
    <Card
      tone='accent'
      role='note'
      aria-label={m.team_intro_title()}
      className='mt-6 flex gap-3'
    >
      <Info className='mt-0.5 size-4 shrink-0 text-ink-secondary' aria-hidden='true' />
      <div className='flex-1'>
        <p className='text-base font-semibold text-ink'>{m.team_intro_title()}</p>
        <p className='mt-1 max-w-150 text-sm text-ink-secondary'>{m.team_intro_who()}</p>
        <p className='mt-2 max-w-150 text-sm text-ink-secondary'>{m.team_intro_info()}</p>
        <a
          href={helpUrl(getLocale(), 'managers/team/')}
          target='_blank'
          rel='noopener noreferrer'
          className={cn('mt-2', buttonVariants({ variant: 'link', size: 'sm' }))}
        >
          {m.team_intro_more()}
        </a>
      </div>
      <IconButton
        variant='quiet'
        size='sm'
        aria-label={m.team_intro_close()}
        className='-mt-1 -mr-1 text-ink-muted'
        onClick={() => {
          dismissTeamIntro();
          setDismissed(true);
        }}
      >
        <X className='size-4' aria-hidden='true' />
      </IconButton>
    </Card>
  );
}
